
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "UtilitySelect"
})
export default class UtilitySelect extends Vue {
  @Prop({ required: true })
  availableUtilities!: { id: number; key: string }[];

  @Prop({ default: "" })
  activeUtilities!: string;

  @Prop({ default: null })
  pendingChangeRequest!: IPassengerChangeRequest | null;

  addedIds: number[] = [];
  removedIds: number[] = [];

  private parseIds(str: string): number[] {
    if (!str) return [];
    return str
      .split(",")
      .map(s => Number.parseInt(s.trim(), 10))
      .filter(n => !Number.isNaN(n));
  }

  get originalIds(): number[] {
    return this.parseIds(this.activeUtilities);
  }

  get hasPendingChanges(): boolean {
    return !!this.pendingChangeRequest;
  }

  get displayAddedIds(): number[] {
    return this.hasPendingChanges
      ? this.parseIds(this.pendingChangeRequest!.addedUtilities)
      : this.addedIds;
  }

  get displayRemovedIds(): number[] {
    return this.hasPendingChanges
      ? this.parseIds(this.pendingChangeRequest!.removedUtilities)
      : this.removedIds;
  }

  getUtilityAriaLabel(utility: { id: number; key: string }): string {
    const name = this.$t("utility." + utility.key) as string;
    if (this.displayAddedIds.includes(utility.id)) {
      return `${name}, ${this.$t("utility.added")}`;
    } else if (this.displayRemovedIds.includes(utility.id)) {
      return `${name}, ${this.$t("utility.removed")}`;
    }
    return name;
  }

  isUtilityActive(id: number): boolean {
    if (this.originalIds.includes(id)) {
      return !this.displayRemovedIds.includes(id);
    }
    return this.displayAddedIds.includes(id);
  }

  toggleUtility(id: number) {
    if (this.originalIds.includes(id)) {
      const idx = this.removedIds.indexOf(id);
      if (idx >= 0) {
        this.removedIds.splice(idx, 1);
      } else {
        this.removedIds.push(id);
      }
    } else {
      const idx = this.addedIds.indexOf(id);
      if (idx >= 0) {
        this.addedIds.splice(idx, 1);
      } else {
        this.addedIds.push(id);
      }
    }
    this.$emit("change", { added: [...this.addedIds], removed: [...this.removedIds] });
  }
}
